export const Image = (props) => {
    return (<img
        src={props.src}
        alt={props.alt}
        height={props.height}
        width={props.width}
        style={{ objectFit: props.objectFit }}
        className={props.className}
        onClick={props.onClick}
    />)
}